import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'macAddress',
    pure: false,
    standalone: false
})
export class MacAddressPipe implements PipeTransform {
   transform(macAddress: string): string {
      return formatMacAddress(macAddress);
   }
}

export function formatMacAddress(macAddress: string) {
   if (!macAddress) {
      return '';
   }

   // Remove any non-hexadecimal characters
   const cleanValue = macAddress.replace(/[^0-9a-fA-F]/g, '');

   // Format the MAC address with colons
   const formattedMac = cleanValue.match(/.{1,2}/g)?.join(':') || '';

   return formattedMac.toUpperCase();
}
